//#region src/schema/helpers/is-type-object.ts
var e = (e) => {
	if (typeof e != "object" || !e || Array.isArray(e) || "oneOf" in e || "anyOf" in e || "allOf" in e || "not" in e) return !1;
	let t = "type" in e;
	if (t && Array.isArray(e.type)) return e.type.includes("object");
	let n = t && e.type === "object";
	if (n) return !0;
	if (t && !n) return !1;
	let r = "properties" in e, i = "additionalProperties" in e, a = "patternProperties" in e;
	return r || i || a;
};
//#endregion
export { e as isTypeObject };

//# sourceMappingURL=is-type-object.js.map